export default interface IRoleFormData {
    isEditMode: boolean;
    requestId: string;
    id: string;
    isEnabled:boolean;
    name: string;
    description: string;
}

export class RoleFormData implements IRoleFormData {
    isEditMode: boolean;
    requestId: string;
    id: string;
    isEnabled:boolean;
    name: string;
    description: string;

    constructor( isEditMode: boolean,
        requestId: string,
        id: string,
        isEnabled:boolean,
        name: string,
        description: string,
        ) {

        this.isEditMode = isEditMode;
        this.requestId = requestId;
        this.id = id;
        this.isEnabled = isEnabled;
        this.name =  name;
        this.description = description;
    }
}